import React from "react";

import '../Style.css';

import Benchplatformscale from '../Assets/Images/Categories/Bench-platform-scale.png';
import Healthcare from '../Assets/Images/Categories/Health-care.png';
import JewelleryScale from '../Assets/Images/Categories/JewelleryScale.png';
import Minitabletopimg from '../Assets/Images/Categories/Mini-tabletop.png';
import Platformscale from '../Assets/Images/Categories/Platform-scale.png';
import Protablescale from '../Assets/Images/Categories/Protable-scale.png';
import Tabletopscale from '../Assets/Images/Categories/Table-top-scale.png';
import heavydutyscale from '../Assets/Images/Categories/heavy-duty-scale.png';
import value_counting from '../Assets/Images/Economic Scales/Cash counting machine/value_counting.png';
import price_computing from '../Assets/Images/Economic Scales/Price computing scale/price_computing.png';
import crane_scale from '../Assets/Images/Categories/1_ton.png';


import { BiRightTopArrowCircle } from "react-icons/bi";

function AllCategory() {
    return (
        <div>


            <section className="py-5">
                <div className="container  py-lg-5">
                    <div class="mt-3">
                        <p class="section-top-heading-css py-3 py-lg-0">All Categories</p>

                    </div>
                    <div className="row   row-cols-lg-4 row-cols-2 min-vh-100 justify-content-center g-lg-4 g-2 align-items-center ">
                        <div className="col ">
                            <div className="border-sample-css ">
                                <div className="card home-product-card-css h-100">
                                    <div className="text-center image-stretch-css"><img className="product-swiper-image" src={JewelleryScale} /></div>
                                    <p className="about-card-heading-css text-center">
                                        Jewellery Scale
                                    </p>
                                    <p className="about-card-para-css">1 Product</p>
                                    <button className="btn mx-2 mt-3">
                                        <a href="/Jewelleryscale_1" className="more-btn-css-styling">
                                            View All <BiRightTopArrowCircle className="ms-2 button-icon-css" />
                                        </a>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="col ">
                            <div className="border-sample-css ">
                                <div className="card home-product-card-css h-100">
                                    <div className="text-center image-stretch-css"><img className="product-swiper-image" src={Minitabletopimg} /></div>
                                    <p className="about-card-heading-css text-center">
                                        Mini table top scale</p>
                                    <p className="about-card-para-css">8 Products</p>

                                    <button className="btn mx-2 mt-3">
                                        <a href="/Minitabletop" className="more-btn-css-styling">
                                            View All <BiRightTopArrowCircle className="ms-2 button-icon-css" />
                                        </a>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="col ">
                            <div className="border-sample-css ">
                                <div className="card home-product-card-css h-100">
                                    <div className="text-center image-stretch-css"><img className="product-swiper-image" src={Tabletopscale} /></div>
                                    <p className="about-card-heading-css text-center">
                                        Table top Scale</p>
                                    <p className="about-card-para-css">5 Products</p>
                                    <button className="btn mx-2 mt-3">
                                        <a href="/Tabletopscale" className="more-btn-css-styling">
                                            View All <BiRightTopArrowCircle className="ms-2 button-icon-css" />
                                        </a>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="col ">
                            <div className="border-sample-css ">
                                <div className="card home-product-card-css h-100">
                                    <div className="text-center image-stretch-css"><img className="product-swiper-image" src={Protablescale} /></div>
                                    <p className="about-card-heading-css text-center">
                                        Portable scale</p>
                                    <p className="about-card-para-css">6 Products</p>
                                    <button className="btn mx-2 mt-3">
                                        <a href="/Portablescale" className="more-btn-css-styling">
                                            View All <BiRightTopArrowCircle className="ms-2 button-icon-css" />
                                        </a>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="col ">
                            <div className="border-sample-css ">
                                <div className="card home-product-card-css h-100">
                                    <div className="text-center image-stretch-css"><img className="product-swiper-image" src={Platformscale} /></div>
                                    <p className="about-card-heading-css text-center">
                                        Platform Scale
                                    </p>
                                    <p className="about-card-para-css">3 Products</p>
                                    <button className="btn mx-2 mt-3">
                                        <a href="/Platformscale" className="more-btn-css-styling" >
                                            View All <BiRightTopArrowCircle className="ms-2 button-icon-css" />
                                        </a>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="col ">
                            <div className="border-sample-css ">
                                <div className="card home-product-card-css h-100">
                                    <div className="text-center image-stretch-css"><img className="product-swiper-image" src={heavydutyscale} /></div>
                                    <p className="about-card-heading-css text-center">
                                        Heavy duty platform Scale</p>
                                    <p className="about-card-para-css">2 Products</p>
                                    <button className="btn mx-2 mt-3">
                                        <a href="/Heavydutyplatformscale" className="more-btn-css-styling">
                                            View All <BiRightTopArrowCircle className="ms-2 button-icon-css" />
                                        </a>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="col ">
                            <div className="border-sample-css ">
                                <div className="card home-product-card-css h-100">
                                    <div className="text-center image-stretch-css"><img className="product-swiper-image" src={Healthcare} /></div>
                                    <p className="about-card-heading-css text-center">
                                        Health scale </p>
                                    <p className="about-card-para-css">3 Products</p>
                                    <button className="btn mx-2 mt-3">
                                        <a href="/Healthscale" className="more-btn-css-styling">
                                            View All <BiRightTopArrowCircle className="ms-2 button-icon-css" />
                                        </a>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="col ">
                            <div className="border-sample-css ">
                                <div className="card home-product-card-css h-100">
                                    <div className="text-center image-stretch-css"><img className="product-swiper-image" src={crane_scale} /></div>
                                    <p className="about-card-heading-css text-center">
                                        Crane scale</p>
                                    <p className="about-card-para-css">4 Products</p>
                                    <button className="btn mx-2 mt-3 ">
                                        <a href="/Cranescale" className="more-btn-css-styling ">
                                            View All <BiRightTopArrowCircle className="ms-2 button-icon-css" />
                                        </a>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="col ">
                            <div className="border-sample-css ">
                                <div className="card home-product-card-css h-100">
                                    <div className="text-center image-stretch-css"><img className="product-swiper-image" src={value_counting} /></div>
                                    <p className="about-card-heading-css text-center">
                                        Cash counting machine</p>
                                    <p className="about-card-para-css">3 Products</p>
                                    <button className="btn mx-2 mt-3">
                                        <a href="/Cashcountingmachine" className="more-btn-css-styling">
                                            View All <BiRightTopArrowCircle className="ms-2 button-icon-css" />
                                        </a>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="col ">
                            <div className="border-sample-css ">
                                <div className="card home-product-card-css h-100">
                                    <div className="text-center image-stretch-css"><img className="product-swiper-image" src={price_computing} /></div>
                                    <p className="about-card-heading-css text-center">
                                        Price computing scale</p>
                                    <p className="about-card-para-css">2 Products</p>
                                    <button className="btn mx-2 mt-3">
                                        <a href="/Pricecomputingscale" className="more-btn-css-styling">
                                            View All <BiRightTopArrowCircle className="ms-2 button-icon-css" />
                                        </a>
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div className="col ">
                            <div className="border-sample-css ">
                                <div className="card home-product-card-css h-100">
                                    <div className="text-center image-stretch-css"><img className="product-swiper-image" src={Benchplatformscale} /></div>
                                    <p className="about-card-heading-css text-center mx-1">Bench platform Scale</p>
                                    <p className="about-card-para-css">1 Products</p>
                                    <button className="btn mx-2 mt-3">
                                        <a href="/BTB_16" className="more-btn-css-styling">
                                            View All <BiRightTopArrowCircle className="ms-2 button-icon-css" />
                                        </a>
                                    </button>
                                </div>
                            </div>
                        </div>


                    </div>


                </div>
            </section>





        </div >

    );
}

export default AllCategory;
